export default "__VITE_ASSET__Ck15TXeM__"